import { useCallback } from 'react';

import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import {
  detailActions,
  detailSelectors,
} from 'store/reducers/crawlerReducer/detailSlice';
import { useToast } from 'hooks/useToast';
import * as crawlerApi from 'api/crawlerApi';
import { useListStore } from './useListStore';
import { mapCrawlerToFormFields } from '../types/crawlerBaseFormFields';

export const useDeleteStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchCrawlers } = useListStore();
  const selectedCrawler = useAppSelector(detailSelectors.selectedCrawler);
  const isOpenModal = useAppSelector(detailSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(detailActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteCrawler = useCallback(() => {
    if (selectedCrawler) {
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(detailActions.updateLoadingStatus(true));
        const result = await crawlerApi.deleteCrawler(selectedCrawler.id);
        if (result.ok) {
          toast({
            status: 'success',
            description: `クローラーを削除しました。`,
          });

          onCloseModal();
          dispatch(detailActions.modalOpened(null));
          void fetchCrawlers();
        } else {
          toast({
            status: 'error',
            description: `クローラーの削除に失敗しました。`,
          });
        }
        dispatch(detailActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `クローラーの削除に失敗しました。`,
        });
      });
    }
  }, [selectedCrawler, toast, dispatch, onCloseModal, fetchCrawlers]);

  return {
    /** クローラーの内容 */
    values: mapCrawlerToFormFields(selectedCrawler || {}),
    /** クローラーの削除 */
    onDeleteCrawler,
    /** クローラーの削除キャンセル */
    onCloseModal,
    /** クローラー削除確認モーダルの表示状態 */
    isOpenModal,
  };
};
